<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M4.5 5.2q.2-2 2.3-2.2h12.9q2.1.2 2.3 2.2V14q-.2 2-2.3 2.2H12v-2.4h3.1q.3 0 .5-.2l.2-.4-.2-.4-.5-.2H12V9q0-1-.7-1.7t-1.8-.7h-5zm-.6 2.6a2 2 0 0 0-1.4.5Q2 9 2 9.6v9.6q0 .8.5 1.3T4 21h5q.8 0 1.3-.5t.6-1.3V9.6q0-.8-.6-1.3A2 2 0 0 0 9 7.8zM5 18q0-.3.2-.4l.5-.2H7q.3 0 .4.2.3 0 .2.4 0 .3-.2.4l-.4.2H5.8q-.3 0-.5-.2z"
    />
  </svg>
</template>
